<div class="md:flex mb-6">
  <div class="xl:w-96 lg:w-80 md:w-64">
    <label class="block text-gray-500 md:mt-2 font-bold md:text-left mb-1 md:mb-0 pr-4 md:text-lg lg:text-xl" for="inline-full-name"> {{titleLabel}} </label>
  </div>
  <div class="md:w-full">
    <input type="{{typeInput}}" class="rounded-lg border border-solid border-gray-400 outline-none w-full py-1.5 px-4 focus:outline-none focus:border-primary "
      [formControl]="inputControl" [placeholder]="placeholder" />
    <!-- validate -->
    <ng-content></ng-content>
  </div>
</div>